import * as api from 'app/resources/game-images.api';

export const INSTANT_GAME_TYPE = 'scratch';
export const DRAW_GAME_TYPE = 'online';
export const VLT_GAME_TYPE = 'vlt-games';

const FETCH_GAME_IMAGES_REQUEST = 'FETCH_GAME_IMAGES_REQUEST';
const FETCH_GAME_IMAGES_SUCCESS = 'FETCH_GAME_IMAGES_SUCCESS';
const FETCH_GAME_IMAGES_FAILURE = 'FETCH_GAME_IMAGES_FAILURE';
const CLEAR_GAME_IMAGES = 'CLEAR_GAME_IMAGES';
const UPDATE_GAME_IMAGES = 'UPDATE_GAME_IMAGES';
const UPDATE_GAME_IMAGES_REQUEST = 'UPDATE_GAME_IMAGES_REQUEST';
const UPDATE_GAME_IMAGES_SUCCESS = 'UPDATE_GAME_IMAGES_SUCCESS';
const UPDATE_GAME_IMAGES_FAILURE = 'UPDATE_GAME_IMAGES_FAILURE';

export const fetchGameImagesRequest = () => ({
  type: FETCH_GAME_IMAGES_REQUEST,
  isLoading: true,
});

export const fetchGameImagesSuccess = (games, pagination) => ({
  type: FETCH_GAME_IMAGES_SUCCESS,
  isLoading: false,
  games,
  pagination,
});

export const fetchGameImagesFailure = () => ({
  type: FETCH_GAME_IMAGES_FAILURE,
  isLoading: false,
});

export const fetchGameImages = (params) => async (dispatch) => {
  try {
    dispatch(fetchGameImagesRequest());
    const { filters: { type } } = params;
    const { content, ...pagination } = await api.fetchGameImages(type, params);
    dispatch(fetchGameImagesSuccess(content, pagination));
  } catch (error) {
    console.error('FETCH_GAME_IMAGES', error);
    dispatch(fetchGameImagesFailure());
  }
};
export const updateGameImage = (gameImage) => ({
  type: UPDATE_GAME_IMAGES,
  gameImage,
});

export const clearGameImages = () => ({
  type: CLEAR_GAME_IMAGES,
});

export const updateGameImagesRequest = () => ({
  type: UPDATE_GAME_IMAGES_REQUEST,
  isSaving: true,
});

export const updateGameImagesSuccess = (game) => ({
  type: UPDATE_GAME_IMAGES_SUCCESS,
  isSaving: false,
  game,
});

export const updateGameImagesFailure = () => ({
  type: UPDATE_GAME_IMAGES_FAILURE,
  isSaving: false,
});

export const updateGameImages = (gameType, gameImage) => async (dispatch) => {
  try {
    dispatch(updateGameImagesRequest());
    const { result } = await api.updateGameImages(gameType, gameImage.gameId, gameImage.image);
    dispatch(updateGameImagesSuccess(result));
  } catch (error) {
    console.error('UPDATE_GAME_IMAGES', error);
    dispatch(updateGameImagesFailure());
  }
};

export default {
  FETCH_GAME_IMAGES_REQUEST,
  FETCH_GAME_IMAGES_SUCCESS,
  FETCH_GAME_IMAGES_FAILURE,
  UPDATE_GAME_IMAGES,
  CLEAR_GAME_IMAGES,
  UPDATE_GAME_IMAGES_REQUEST,
  UPDATE_GAME_IMAGES_SUCCESS,
  UPDATE_GAME_IMAGES_FAILURE,
};



// WEBPACK FOOTER //
// ./src/modules/app/actions/game-images.actions.js